import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

// https://query2.finance.yahoo.com/v10/finance/quoteSummary/AAPL?modules=price
// 'summaryProfile', 'financialData', 'recommendationTrend',
//   'upgradeDowngradeHistory', 'earnings', 'price', 'summaryDetail',
//   'defaultKeyStatistics', 'calendarEvents'
@Injectable({
  providedIn: 'root'
})
export class QuoteService {
  PROXY = environment.proxy_all_origins;
  CORS_MODE: RequestMode = environment.cors_mode as RequestMode;
  quoteSubject$ = new Subject();

  getQuote(symbol: string) {
    const baseUrl = `https://query2.finance.yahoo.com/v10/finance/quoteSummary/${symbol}?modules=`;
    const urls = [
      this.PROXY + baseUrl + 'price',
      this.PROXY + baseUrl + 'summaryDetail'
    ];
    const fetchData = url => {
      return new Promise((res, err) => {
        // const headers = { 'Access-Control-Allow-Origin': '*' };
        // fetch(url)
        fetch(url)
          .then((response) => {
            return response.text();
          })
          .then(data => {
            res(JSON.parse(data));
          });
      });
    };
    const promises = [fetchData(urls[0]), fetchData(urls[1])];
    Promise.all(promises).then(res => {
      this.quoteSubject$.next(res);
    });
  }
}
